export default __webpack_public_path__ + "static/media/leaverigthbottom.f58ced55.svg";